<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication" role="doc-dedication">
<div class="inline_groupch"><span aria-label="page v" id="page_v" role="doc-pagebreak"><img alt="Image" class="portrait_70" src="e9781481403887/images/f000v-01.jpg"/></span></div>
<p class="ded2">For</p>
<p class="ded">Angela and Sophia,</p>
<p class="ded">my WondLa</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9487b918